import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddRiderService } from 'src/app/shared/services/add-rider.service';
import { BaseFormGroup } from '../../../../shared/form-input-components/base-form-group';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { CreateBookingService } from '../../create-booking.service';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';
import { emailValidator } from 'src/app/shared/validators/email-validator';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: "app-add-rider",
  templateUrl: "./add-rider.component.html",
  styleUrls: ["./add-rider.component.scss"],
})
export class AddRiderComponent extends BaseFormGroup implements OnInit {
  public tabValue = "FirmMember";
  formDetails: any;
  form: FormGroup;
  riderForm: any;
  riderAddress = [];
  passenger: any;
  tabData: any = this.getTabDetails();
  maskEnable: boolean = false;
  editBookingRiderForm: any;
  editBookingMode: boolean = false;
  formArray: any;
  isAlternateMobileMaskable: boolean;
  isMobileMaskable: boolean;
  formConfigs = [];
  radiolist=[
    {label: 'Yes', value: 'Yes'},
    {label: 'No', value: 'No'}
  ]
  selectedRadioValue= {label: 'Yes', value: 'Yes'}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddRiderComponent>,
    public addRiderService: AddRiderService,
    private formBuilder: FormBuilder,
    private createBookingService: CreateBookingService,
    private commonBookingService: CommonBookingService,
    private changeDetect: ChangeDetectorRef,
    private utilService: UtilService
  ) {
    super();
    this.editBookingRiderForm = data.editRideform;
    this.editBookingMode = data.editBooking;
  }

  ngOnInit(): void {
    this.formArray = this.addRiderService.getFormArray();
    this.formConfigs = JSON.parse(JSON.stringify(this.addRiderService.formConfig));
    this.createNewRiderForm();
    if (this.editBookingMode) {
      this.editBookingRiderForm.enable();
      const riderTypeId = this.editBookingRiderForm.get("riderTypeId").value;
      riderTypeId == "Self" || riderTypeId == "Firm Member" ? (this.tabValue = "FirmMember") : (this.tabValue = "Guest");
      this.riderForm.controls.forEach((control) => {
        if (control instanceof FormGroup) 
          control.patchValue(this.editBookingRiderForm.value);
      });
      this.isDataPresent();
      this.isNumberMaskable(); 
    }
  }

  createNewRiderForm() {
    const formGroupConfig: any = {};
    this.addRiderService.formConfig.forEach((config) => {
      const validators = [];
      if (config.config.mandatory) validators.push(Validators.required);
      if (config.elementKey === "email") validators.push(emailValidator);

      formGroupConfig[config.elementKey] = new FormControl(
        config.config.defaultValue,
        validators
      );
    });
    const formGroup = this.formBuilder.group(formGroupConfig);
    this.form = this.formBuilder.group({
      formArray: this.formBuilder.array([formGroup]),
    });
    this.riderForm = this.form.get("formArray") as FormArray;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onTabChange(event) {
    this.tabValue = event;
    this.createNewRiderForm();
  }

  onCodeChange($event: any, form: FormControl) {
    form.setValue(`+${$event}`);
  }

  getTabDetails() {
    return [
      {
        value: "FirmMember",
        label: this.addRiderService.getFirmMemberKey(),
      },
      {
        value: "Guest",
        label: this.addRiderService.getGuestKey(),
      },
    ];
  }

  onRiderSelect(riderObj: any) {
    this.changeDetect.detectChanges();
    if (!riderObj.primaryAddress) riderObj.primaryAddress = {};
    if (!riderObj.primaryAddress.home) riderObj.primaryAddress.home = {};
    if (!riderObj.office) riderObj.office = {};

    riderObj.primaryAddress.home.employeeId = riderObj.emplId;
    riderObj.primaryAddress.home.isSaved = true;
    riderObj.primaryAddress.home.type = `${riderObj.name}'s Home`;
    this.riderAddress.push(riderObj.primaryAddress.home);
    this.commonBookingService.updateHomeAddressesOfRiders(this.riderAddress);
    this.passenger = this.addRiderService.formatRiderInfo(
      riderObj,
      this.addRiderService.currentUser.employeeId === riderObj.employeeId
        ? this.addRiderService.getSelfKey()
        : this.addRiderService.getFirmMemberKey()
    );

    if (this.passenger) {
      if (!this.riderForm.controls["alternateMobile"])
        this.passenger["alternateMobile"] = "";
      if (!this.riderForm.controls["alternatePhoneCode"])
        this.passenger["alternatePhoneCode"] = "";
      for (const control of this.riderForm.controls) {
        control.patchValue(this.passenger);
      }
      this.isDataPresent();
      this.isNumberMaskable();
    }
  }

  isDataPresent(){
    this.formConfigs.forEach(element => {
      if(this.riderForm.controls[0]?.get(element.elementKey)?.value){
        element.config.isDataPresent = true;
      }else{
        element.config.isDataPresent = false;
      }
    });
  }

  isNumberMaskable(){
    if(this.riderForm.controls[0].get('mobile')?.value){
      this.isMobileMaskable = true;
    }else{
      this.isMobileMaskable = false;
    }
    if(this.riderForm.controls[0].get("alternateMobile")?.value){
      this.isAlternateMobileMaskable = true;
    }else{
      this.isAlternateMobileMaskable = false;
    }
  }

  addPassenger() {
    if (this.tabValue == "FirmMember" && this.passenger) {
      const findIndex = this.formArray.controls.findIndex((formGroup) => {
          return (
            formGroup.controls.emplId.value ===
            this.riderForm.controls[0].get("emplId").value
          );
        });
      //add if new employee
      if (findIndex == -1) {
        this.passenger.phoneCode=this.riderForm.controls[0].get('phoneCode').value
        this.passenger.alternateMobile =
          this.riderForm.controls[0].get("alternateMobile").value;
        this.passenger.alternatePhoneCode =
          this.riderForm.controls[0].get("alternatePhoneCode").value;
        this.addRiderService.updateTableWithRider(this.passenger);
      } else this.setDuplicateRiderError();
    } else {
      if (this.editBookingMode) {
        const findIndex = this.formArray.controls.findIndex((formGroup) => {
          return (
            formGroup.controls.email.value ===
            this.riderForm.controls[0].get("email").value
          );
        });

        if (findIndex != -1) {
          if (this.formArray && this.formArray.length > findIndex) {
            const formGroupAtIndex = this.formArray.at(findIndex) as FormGroup;
            if (formGroupAtIndex){
              formGroupAtIndex.enable();
              formGroupAtIndex.patchValue(this.riderForm.at(0).value);
            }
          }
        }
      } else {
       
          const travellerIdControl = new FormControl(
            this.utilService.generateUuid()
          );
          //add guest
          const isNewControl = new FormControl(true);
          this.riderForm.controls.forEach((control: FormGroup) => {
            control.addControl("travellerId", travellerIdControl);
            control.addControl("isNew", isNewControl);
            control.addControl("emplGuid", new FormControl(''));
          });
          this.createBookingService.newRiders.push(travellerIdControl);
          this.riderForm.controls[0].get("riderTypeId").setValue("Guest");
          this.riderForm.controls[0].get("riderType").setValue(this.addRiderService.getGuestKey());
          this.formArray.push(this.riderForm.controls[0]);
        
      }
    }
  }

  getUserOptionLabel(option: any) {
    return `${option.employeeName} (${option.employeeId})`;
  }

  getUserOptionValue(option: any) {
    return option;
  }

  riderSearch = (searchQuery: string) => {
    searchQuery = searchQuery.replace(/;/g, "");
    return this.createBookingService.fetchEmployees(searchQuery);
  };

  setDuplicateRiderError() {
    this.addRiderService.showDuplicateRiderError = true;
    this.addRiderService.duplicateRiderMsg = "Duplicate Rider is not allowed";
    setTimeout(
      () => (this.addRiderService.showDuplicateRiderError = false),
      3000
    );
  }
  clearForm(event){
   if(event) this.createNewRiderForm();
  }

  radioInputChange(event){
    let config = this.formConfigs.find(config=>config.elementKey=='email')
    if(event=='No'){
      config.config.mandatory=false
      this.riderForm.controls[0].get('email').setValidators(null)
      this.riderForm.controls[0].get('email').disable()
    }
    else{
      config.config.mandatory=true
      this.riderForm.controls[0].get('email').setValidators([ emailValidator, Validators.required]); 
      this.riderForm.controls[0].get('email').enable();
      this.riderForm.updateValueAndValidity();
    }
    this.changeDetect.detectChanges()
  }
}
